import React, { useEffect, useState } from "react";
import { api, trackEvent } from "@/lib/apiClient";
import Layout, { useSEO } from "@/components/Layout";
import { Section, Overline, BlueRule, Button } from "@/components/primitives";
import NewsletterSection from "@/components/NewsletterSection";

const TRACKS = [
  { key: "LEARN", title: "Learn", desc: "Courses and guided programs to build knowledge and practice over time." },
  { key: "EXPERIENCE", title: "Experience", desc: "Workshops, seminars and speaking programs—live and immersive." },
  { key: "APPLY", title: "Apply", desc: "Assessments, exercises, tools and practical resources to put ideas to work." },
];

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  useSEO({ title: "Programs | Impactful Mindset", description: "Courses, workshops, seminars, speaking programs and practical tools from Impactful Mindset." });
  useEffect(() => { api.get("/programs").then((r) => setPrograms(r.data)); }, []);

  return (
    <Layout>
      <Section className="pt-20 pb-10">
        <Overline>Programs</Overline>
        <h1 className="font-serif-display text-4xl sm:text-5xl font-bold mt-4 text-[#111827]">Learn, experience, apply</h1>
        <BlueRule className="mt-6" />
        <p className="text-lg text-slate-600 mt-6 max-w-2xl leading-relaxed">
          Structured ways to go beyond reading—into practice, experience and real change.
        </p>
      </Section>

      {TRACKS.map((track) => {
        const items = programs.filter((p) => p.track === track.key);
        return (
          <Section key={track.key} className="py-12 border-t border-slate-200">
            <span className="text-xs tracking-[0.2em] font-bold text-[#0F2C59]">{track.key}</span>
            <h2 className="font-serif-display text-3xl font-semibold mt-2 text-[#111827]">{track.title}</h2>
            <p className="text-slate-600 mt-3 max-w-2xl leading-relaxed">{track.desc}</p>
            <div className="grid md:grid-cols-3 gap-6 mt-8">
              {items.length === 0 ? (
                <p className="text-slate-400 text-sm">Programs coming soon.</p>
              ) : items.map((p) => (
                <div key={p.id} data-testid={`program-card-${p.slug}`} className="border border-slate-200 overflow-hidden flex flex-col">
                  <div className="aspect-[16/10] bg-slate-100 overflow-hidden"><img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover" /></div>
                  <div className="p-6 flex-1 flex flex-col">
                    {p.status === "coming_soon" && <Overline className="!text-slate-400">Coming Soon</Overline>}
                    <h3 className="font-serif-display text-lg font-semibold mt-2 text-[#111827]">{p.title}</h3>
                    <p className="text-slate-600 text-sm mt-2 leading-relaxed flex-1">{p.description}</p>
                    <Button to="/join" variant="secondary" className="mt-5 w-full" data-testid={`program-cta-${p.slug}`}
                      onClick={() => trackEvent("program_interest", { program: p.slug })}>{p.cta_text || "Learn More"}</Button>
                  </div>
                </div>
              ))}
            </div>
          </Section>
        );
      })}

      <NewsletterSection />
    </Layout>
  );
}
